import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import SwiperCore, { Navigation } from "swiper";
import styled, { createGlobalStyle } from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";

SwiperCore.use([Navigation]);

const NavigationButton = styled.div`
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  &.swiper-button-disabled {
    display: none;
  }
  &.swiper-button-prev {
      left:-10px;
      opacity:1;
      &::after {
      content: url('/Site/images/icons/order-details/arrow-circle-left.svg');
    }
  }

  &.swiper-button-next {
      right:-11px;
      opacity:1;
      &::after {
      content: url('/Site/images/icons/order-details/arrow-circle-right.svg');
    }
  }
 
  &.swiper-button-next {
  @media (max-width: 767px) {
    display: none;
  }
`;

const SwiperGlobalStyle = createGlobalStyle`
    .swiper-wrapper {
        height: 100% !important;
    }
    .tickets-carousel {
        height: 100% !important;
    }
    @media (max-width: 767px) {
        .swiper-slide .items-barcode {
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
        }
        .swiper-slide-active .items-barcode {
            opacity: 1;
        }
        .swiper-container {
            overflow: visible;
        }
    }
`;

const SwipeableContainer = ({ type, hasLabel, children }) => {
    const [showNavigation, setShowNavigation] = useState(false);
    const [allowSwipe, setAllowSwipe] = useState(true);
    const [swiperInstance, setSwiperInstance] = useState(null);
    const isMobile = useMediaQuery("(max-width:767px)");
    const [centeredSlides, setCenteredSlides] = useState(isMobile ? true : false);

    const setNavigationVisibility = () => {
        if (window.innerWidth >= 768) {
            if (!(children.length < 4)) {
                setShowNavigation(true);
            }
        } else {
            setShowNavigation(false);
        }
    };
    useEffect(() => {
        setNavigationVisibility();
        window.addEventListener("resize", setNavigationVisibility);
        return () => window.removeEventListener("resize", setNavigationVisibility);
    }, []);

    useEffect(() => {
        const syncSlideHeights = () => {
            const slideWrappers = document.querySelectorAll(`.${type}-carousel .swiper-slide > div`);
            let maxHeight = 0;
    
            slideWrappers.forEach((slide) => {
                slide.style.height = "auto"; // Reset any previous height
                const height = slide.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
    
            slideWrappers.forEach((slide) => {
                slide.style.height = `${maxHeight}px`;
            });
        };
    
        // syncSlideHeights();
        setTimeout(syncSlideHeights, 50);
        window.addEventListener("resize", syncSlideHeights);
    
        return () => window.removeEventListener("resize", syncSlideHeights);
    }, [children]);

    useEffect(() => {
        const updateSwipeStatus = () => {
            const isLargeScreen = typeof window !== 'undefined' && window.innerWidth > 1320;
            const isMdScreen = typeof window !== 'undefined' && window.innerWidth <= 1320 && window.innerWidth > 650;
            const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
            const count = React.Children.count(children);

            const allowTouch = !(
                (isLargeScreen && ((type === "tickets" && count <= 4) || (type === "products" && count <= 4))) ||
                (isMdScreen && ((type === "tickets" && count <= 2) || (type === "products" && count <= 2)))
            );

            const hasCenteredSlides = isMobile ? true : false;
    
            setAllowSwipe(allowTouch);
            setCenteredSlides(hasCenteredSlides);
    
            // Manually update Swiper instance if available
            if (swiperInstance) {
                swiperInstance.allowTouchMove = allowTouch;
                swiperInstance.centeredSlides = hasCenteredSlides;
            }
        };
    
        updateSwipeStatus();
        window.addEventListener("resize", updateSwipeStatus);
        return () => window.removeEventListener("resize", updateSwipeStatus);
    }, [children, type, swiperInstance]);

    return (
        <>
        <SwiperGlobalStyle/>
        <div style={{ position: "relative" }} className={`${type}-carousel`}>
            <Swiper
                spaceBetween={16}
                slidesPerView="auto"
                centeredSlides={centeredSlides}
                freeMode={false}
                allowTouchMove={allowSwipe}
                onSwiper={setSwiperInstance}
                navigation={
                    showNavigation
                        ? {
                            nextEl: `.${type}-arrow.swiper-button-next`,
                            prevEl: `.${type}-arrow.swiper-button-prev`,
                        }
                        : false
                }
            >
                {React.Children.map(children, (child, index) => (
                    <SwiperSlide
                        key={index}
                        style={{ width: "fit-content", display: "flex", height: "100%" }}
                    >
                        <div style={{ height: '100%', display: 'flex' }}>{child}</div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {showNavigation && (
                <>
                    <NavigationButton className={`${type}-arrow swiper-button-prev`} />
                    <NavigationButton className={`${type}-arrow swiper-button-next`} />
                </>
            )}
        </div>
        </>
    );
}


export default SwipeableContainer;
